export const token = new URLSearchParams(window.location.search).get(
    'previewToken',
);

export default {
    token,
};
